import isNil from 'lodash/isNil'
import { useMemo } from 'react'

import { useSubscriptionLimits } from '../../../hooks/useSubscriptionLimits'
import { useOpenBankingAccounts } from './useOpenBankingAccounts'

interface UseBankConnectionLimitResult {
  isLimitReached: boolean
}

export const useBankConnectionLimit = (): UseBankConnectionLimitResult => {
  const { bankConnectionsLimit, isLoading: isLoadingMetrics } = useSubscriptionLimits()
  const { openBankingAccounts, isLoading: isLoadingAccounts } = useOpenBankingAccounts()

  const activeConnectionsCount = useMemo(() => {
    if (!openBankingAccounts) {
      return 0
    }
    return openBankingAccounts.filter((account) => !!account.externalAccountId).length
  }, [openBankingAccounts])

  const isLoading = isLoadingMetrics || isLoadingAccounts

  const isLimitReached = useMemo(() => {
    if (isLoading) {
      return true
    }

    if (isNil(bankConnectionsLimit)) {
      return false
    }

    return activeConnectionsCount >= bankConnectionsLimit
  }, [activeConnectionsCount, bankConnectionsLimit, isLoading])

  return {
    isLimitReached,
  }
}
